import type { ObjectValuesType } from '@app/types'

export const REPORT_STATUSES = {
  inProgress: 'IN_PROGRESS',
  done: 'DONE',
  failed: 'FAILED'
} as const

export type ReportStatusType = ObjectValuesType<typeof REPORT_STATUSES>

export interface ReportFailureDetails {
  message?: string | null
  detail?: string | null
}

export interface Report extends ReportFailureDetails {
  id: string
  status: ReportStatusType
  file: string | null
  createdAt: string
  updatedAt: string
}

export interface RetrieveReport extends ReportFailureDetails {
  id: string
  status: ReportStatusType | null
  file: string | null
  createdAt: string
  updatedAt: string
}
